import { useEffect, useState } from 'react'
import { Box, Flex, Tab, TabList, TabPanel, TabPanels, Tabs, Image, useToast } from "@chakra-ui/react";
import { RiErrorWarningLine } from "react-icons/ri";
import { IoCloudUploadOutline } from "react-icons/io5";
import ImageUploading from "react-images-uploading";
import { bindActionCreators } from "redux";
import { uploadFiles, uploadFilesReset } from "../../digital-sales-room/actions/dsr-actions";
import { connect } from "react-redux";
import PageLoader from "../../global/components/helper-components/components/PageLoader";
import LaunchdeckButton from '../../global/components/helper-components/components/LaunchdeckButton';

import { triggerLaunchdeckToast, validateUrlFormat } from '../../global/helpers/global-helpers';
import { TbBrandCake } from "react-icons/tb";
import config from "../../../config/app-config";
import LaunchdeckFormInput from '../../forms/TextInputField/components/LaunchdeckFormInput';
import LaunchdeckFormTextAreaInput from '../../forms/TextInputField/components/LaunchdeckFormTextAreaInput';


const CreatedDsrClientBranding = ({
  createDsrForm,
  setCreateDsrForm,
  handleCreateNewDsr,
  setIsBrandingModal,
  uploadFiles,
  uploadFilesState,
  uploadFilesReset
}) => {
  const { dsrClientWebsite, dsrClientName, dsrLogoUrl, dsrUploadedLogoUrl, dsrTextLogoString } = createDsrForm;
  const { isLoading, results, error } = uploadFilesState;

  const [logoFile, setLogoFile] = useState(null)
  const [textLogo, setTextLogo] = useState(dsrClientName || '')
  const [imageLoaded, setImageLoaded] = useState(false);
  const [imageError, setImageError] = useState(false);

  const textLogoCharacterLimit = 20;

  const [uriInput, setUriInput] = useState(dsrClientWebsite || "")
  const [feedUriInput, setFeedUriInput] = useState("")
  const [searchedUri, setSearchedUri] = useState("")

  const [showInvalidUrlError, setShowInvalidUrlError] = useState(false)

  const [showLogoLoader, setShowLogoLoader] = useState(false)
  const [showLogoImage, setShowLogoImage] = useState(false)
  const [changeLogoMode, setChangeLogoMode] = useState(false)

  const toast = useToast();

  const { maxImageFileSize, acceptedImageFileTypes } = config;

  useEffect(() => {
    if (dsrLogoUrl || dsrTextLogoString || dsrUploadedLogoUrl) {
      handleCreateNewDsr()
    }
  }, [dsrLogoUrl, dsrTextLogoString, dsrUploadedLogoUrl]);


  useEffect(() => {
    if (!isLoading && !error && results.files) {
      setCreateDsrForm({
        ...createDsrForm,
        dsrLogoType: "uploaded-dsr-logo",
        dsrUploadedLogoUrl: `${results?.files[0]?.url}`,
        displayedLogoImageKey: `${results?.files[0]?.key}`,
        dsrLogoUrl: "",
        dsrTextLogoString: ""
      });
      uploadFilesReset();
    }
  }, [results]);

  const handleAcceptProposedLogo = () => {

    const dsrLogoUrl = feedUriInput ? feedUriInput
      : validateUrlFormat(dsrClientWebsite) ?
        `https://logo.clearbit.com/${dsrClientWebsite}`
        : ""

    if (dsrLogoUrl) {
      setCreateDsrForm({
        ...createDsrForm,
        dsrLogoType: dsrLogoUrl ? "cb-dsr-logo" : "",
        dsrLogoUrl: dsrLogoUrl,
        dsrTextLogoString: "",
        dsrUploadedLogoUrl: ""
      })

      if (!dsrLogoUrl) {
        toast(
          triggerLaunchdeckToast({
            useCase: "show-error-state",
            label: "Unfortunately we are unable to set the logo right now. Please try again later.",
            isMobileView: false
          })
        )
      }
    }
  }

  const handeUploadLogo = () => {
    uploadFiles({ files: [logoFile[0].file], containsImages: true })
  }

  const handleAcceptTextLogo = () => {
    setCreateDsrForm({
      ...createDsrForm,
      dsrLogoType: "textual-dsr-logo",
      dsrTextLogoString: textLogo,
      dsrLogoUrl: "",
      dsrUploadedLogoUrl: ""
    })
  }

  const handleImageError = () => {
    setImageError(true)
    setImageLoaded(false)
    setShowLogoImage(false)
    setSearchedUri(uriInput)
    setChangeLogoMode(false)
  };

  const handleImageLoad = () => {
    setImageError(false)
    setImageLoaded(true)
    setShowLogoImage(true)
  };

  const handleInputChange = (event) => {
    if (event.target.name === "logo-search-input") {
      setUriInput(event.target.value)
    } else if (event.target.name === "logo-text-input") {
      if (event.target.value.length <= textLogoCharacterLimit) {
        setTextLogo(event.target.value)
      }
    }
  }

  const handleGetCbLogo = () => {
    setShowLogoLoader(true)
    setShowInvalidUrlError(false)
    const isValidUrl = uriInput ? validateUrlFormat(uriInput) : false;

    if (isValidUrl && uriInput) {
      setFeedUriInput(`https://logo.clearbit.com/${uriInput}`)
      setShowLogoImage(true)

    } else {
      setShowInvalidUrlError(true)
    }
  }

  const handlePressEnter = (event) => {
    if (event.key === 'Enter' && event.target.name === "logo-search-input") {
      setShowLogoLoader(true)
      setShowInvalidUrlError(false)
      const isValidUrl = uriInput ? validateUrlFormat(uriInput) : false;

      if (isValidUrl && uriInput) {
        setFeedUriInput(`https://logo.clearbit.com/${uriInput}`)
        setShowLogoImage(true)

      } else {
        setShowInvalidUrlError(true)
      }
    }
  }

  const handleImageFound = () => {
    setShowLogoLoader(false)
  }

  const displaySearchLogoModule = () => {
    return (
      <Box minW='20em' my='1em' px='2em'>

        <LaunchdeckFormInput
          label='URL'
          name={"logo-search-input"}
          onChange={handleInputChange}
          onPressEnter={handlePressEnter}

          value={uriInput}
          placeholder={`e.g. www.google.com`}
          isRequired={true}

          errorLogic={showInvalidUrlError}
          errorMessage={`Please use a valid weblink`}
        />

        <Flex mt='1em' align='center' justify='center'>
          <LaunchdeckButton name='userProviderUri' label='Search' fontSize='0.8em' py='0.4em' bg='brandDark.500' color='gray.50' onClick={() => handleGetCbLogo()} />
        </Flex>
        <Box fontSize='0.7em' mt='1em' whiteSpace='pre' fontStyle='italic' textAlign='center' color='gray.500'>
          {`Tip: Use 'www.website.com' instead of 'www.website.com/home'`}
        </Box>



      </Box>)
  }

  const [selectedIndex, setSelectedIndex] = useState(0);

  const handleTabClick = (index) => {
    const resetAllInputs = () => {
      setUriInput("")
      setFeedUriInput("")
      setSearchedUri("")
    }

    if (index !== selectedIndex) {
      resetAllInputs();
      setSelectedIndex(index);
    }
  };



  const backButton = (
    <LaunchdeckButton bg='gray.100' color='brandDark.500' onClick={() => setIsBrandingModal(false)} label='Go back' />
  )

  return (
    <Box width='100%'>
      <Tabs defaultIndex={0} width='100%'>
        <TabList padding='0 1.5em'>
          <Tab fontSize='0.875em' fontWeight='500' p='0.75em 1em' onClick={() => handleTabClick(0)}>Search for logo</Tab>
          <Tab fontSize='0.875em' fontWeight='500' p='0.75em 1em' onClick={() => handleTabClick(1)}>Upload logo</Tab>
          <Tab fontSize='0.875em' fontWeight='500' p='0.75em 1em' onClick={() => handleTabClick(2)}>Use textual logo</Tab>
        </TabList>

        <TabPanels padding='1.5em'>
          <TabPanel>
            {(imageError) ?
              <Flex
                direction='column'
                border='1px dashed #b7b7b7'
                borderRadius='0.625em'
                minH='16em'
                justify='center'
                align='center'
                mb='2em'
                className='fade-in'
              >

                {showLogoImage ?
                  <Flex w='100' align='center' direction='column' className='fade-in' >
                    <Box fontSize='1em' fontWeight='600' letterSpacing='1px' color='brandDark.500' textTransform={'uppercase'}>Official logo found</Box>

                    <Flex boxSize='128px' direction='column' mt='1em' mb='1.5em' justify='center' align='center'
                      border={showLogoLoader ? "none" : '1px solid'} borderColor='gray.200' rounded='0.25em' p='0.5em'>

                      <Box display={showLogoLoader ? "block" : "none"}>
                        <PageLoader />
                      </Box>
                      <Box border='2px solid' borderColor='white' rounded='0.5em' bg='white'>
                        <Image src={`${feedUriInput}`} onError={handleImageError} onLoad={handleImageFound} />
                      </Box>
                    </Flex>

                    <Box display={showLogoLoader ? "none" : "block"} >
                      <LaunchdeckButton bg='brandDark.500' color='white'

                        fontSize='0.8em'
                        onClick={() => {
                          setShowLogoImage(false);
                          setChangeLogoMode(true)
                        }}
                        label='Change logo' />
                    </Box>


                  </Flex>
                  :
                  <>
                    {(dsrClientWebsite || imageError) ?
                      <Box textAlign='center'>
                        {changeLogoMode ?
                          <Flex direction='column' align='center' justify='center' py='1em'>
                            <Box fontSize='1em' fontWeight='600' letterSpacing='1px' color='brandDark.500' textTransform={'uppercase'}>Logo Search</Box>
                            <Box as={TbBrandCake} fontSize='3.5em' my='0.25em' />
                          </Flex>
                          :
                          <Box color='brandDark.500'>
                            {searchedUri ?
                              <Box>No record found for <span style={{ fontStyle: 'italic' }}> {searchedUri}</span></Box>
                              :
                              <Flex direction='column' align='center' justify='center' pt='1em'>
                                <Box fontSize='1em' fontWeight='600' letterSpacing='1px' color='brandDark.500' textTransform={'uppercase'}>Logo Search</Box>
                                <Box as={TbBrandCake} fontSize='3.5em' my='0.25em' />
                              </Flex>
                            }
                          </Box>
                        }
                      </Box>
                      : <>
                        <Box mb='1em' textAlign='center' minH='' color='brandDark.500'>
                          Search and use their website's logo
                        </Box>

                      </>}
                    {displaySearchLogoModule()}
                  </>

                }
              </Flex>

              :
              <Flex
                direction='column'
                border='1px dashed #b7b7b7'
                borderRadius='0.625em'
                minH='16em'
                justify='center'
                align='center'
                m='0 1em 2em 1em'
              >
                <Box mb='1em' display='flex' flexDirection='column' alignItems='center' justifyContent='center'>
                  <Flex boxSize='128px' mt='1em' direction='column' mb='3em' justify='center' align='center' border='1px solid' borderColor='gray.200' rounded='0.25em' p='0.5em'>
                    <Image
                      width='3.125em'
                      height='3.125em'
                      src={`https://logo.clearbit.com/${dsrClientWebsite}`}
                      alt="Brand logo"
                      fallback={
                        <PageLoader boxSize='6em' />
                      }
                      onLoad={handleImageLoad}
                      onError={handleImageError}
                    />
                  </Flex>

                  <LaunchdeckButton bg='brandDark.500' color='white'
                    onClick={() => {
                      setShowLogoImage(false);
                      setChangeLogoMode(true)
                      setImageError(true)
                      setUriInput("")
                      setFeedUriInput("")
                      setImageLoaded(false)
                    }}
                    label='Change logo' />

                </Box>
              </Flex>
            }



            <Flex justify='space-between' w='100%' mt='2em'>
              {backButton}
              {(imageLoaded || showLogoImage) && <LaunchdeckButton bg='brand.500' color='gray.50' onClick={handleAcceptProposedLogo} label='Use logo' />}
            </Flex>


          </TabPanel>
          <TabPanel>
            <UploadingLogo logoFile={logoFile} setLogoFile={setLogoFile} isLoading={isLoading} maxImageFileSize={maxImageFileSize} acceptedImageFileTypes={acceptedImageFileTypes} />

            <Flex w='100%'>
              <Flex justify='space-between' w='100%'>
                {backButton}
                {(logoFile && !isLoading)
                  ?
                  <LaunchdeckButton bg='brand.500' color='gray.50' fontSize='0.8em' onClick={handeUploadLogo} label='Upload logo' />
                  :
                  <LaunchdeckButton bg='#CBD5E0' color='#fff' dummy fontSize='0.8em' label='Upload logo' />
                }
              </Flex>
            </Flex>
          </TabPanel>


          <TabPanel >
            <Box
              className='fade-in'
              border='1px dashed #b7b7b7'
              borderRadius='10px'
              minH='16em'
              width='100%'
              p='1.5em 1em'
              justifyContent='center'
              alignItems='center'
              mb='2em'
            >
              <Flex w='100%' direction='column' align='center' justify='center' pb='2em'>
                {/* <Box fontSize='1em' fontWeight='600' letterSpacing='1px' color='brandDark.500' textTransform={'uppercase'} mb='1.5em'>
                  Use text logo
                </Box> */}

                <Flex
                  p='0.5em'
                  h='5em'
                  minW='5em'
                  justifyContent='center' alignItems='center' textAlign='center' color={!textLogo && 'gray.300'}
                  className="default-text-logo-font"
                  fontSize='1.4em'
                  border='2px solid' borderColor='gray.100' rounded='0.5em'
                  whiteSpace='pre-wrap'
                >
                  {textLogo || 'Preview'}
                </Flex>
              </Flex>

              <Flex w='100%' justify='center'>
                <Box width='24em'>
                  <LaunchdeckFormTextAreaInput
                    label='Logo text'
                    name={"logo-text-input"}
                    onChange={handleInputChange}

                    value={textLogo}
                    placeholder="Enter logo text"
                    charLimit={textLogoCharacterLimit}
                  />
                </Box>
              </Flex>
            </Box>
            <Flex w='100%'  >
              <Flex justify='space-between' w='100%'>
                {backButton}

                <LaunchdeckButton bg={textLogo ? 'brand.500' : '#CBD5E0'} color={textLogo ? 'gray.50' : "white"}
                  onClick={textLogo && handleAcceptTextLogo}
                  transition="all 0.3s ease-in-out"
                  dummy={textLogo ? false : true}
                  label='Use text as logo' />

              </Flex>
            </Flex>
          </TabPanel>
        </TabPanels>
      </Tabs>
    </Box>
  )
}

function UploadingLogo({ logoFile, setLogoFile, isLoading, maxImageFileSize, acceptedImageFileTypes }) {

  const onChange = (image) => {
    setLogoFile(image);
  };

  if (isLoading) {
    return (
      <Box w="100%" align="center" >
        <Box px='1em'>
          <PageLoader />
        </Box>
      </Box>
    )
  }

  return (
    <ImageUploading
      maxFileSize={maxImageFileSize}
      value={logoFile}
      onChange={onChange}
      acceptType={acceptedImageFileTypes}
      dataURLKey="logoUrl"
    >
      {({
        imageList,
        onImageUpload,
        errors,
        isDragging,
        dragProps,
      }) => (
        <Box
          style={isDragging ? { color: 'red' } : undefined}
          border='1px dashed #b7b7b7'
          borderRadius='10px'
          minH='16em'
          width='100%'
          display='flex'
          justifyContent='center'
          alignItems='center'
          mb='2em'
          className='fade-in'
        >
          {imageList.length === 0
            ? <Box
              display='flex'
              flexDirection='column'
              justifyContent='center'
              alignItems='center'
              cursor='pointer'
              padding='1em'
              width="100%"
              onClick={onImageUpload}
              {...dragProps}
            >

              <Box fontSize='1em' fontWeight='600' letterSpacing='1px' color='brandDark.500' textTransform={'uppercase'} mb='0.75em'>
                Upload logo image
              </Box>
              <Box mb='1.5em' height='50px' width='50px'>
                <IoCloudUploadOutline style={{ width: '100%', height: '100%' }} fill='#b7b7b7' />
              </Box>

              <Box fontSize='12px' color='gray.500' mb='24px'>
                <p>JPG or PNG, file size no more than 10MB</p>
              </Box>

              <Flex mt='1em' align='center' justify='center'>
                <LaunchdeckButton label='Select image' fontSize='0.8em' py='0.4em' bg='brandDark.500' color='gray.50' />
              </Flex>
            </Box>
            : imageList.length > 0
            &&
            <Box>
              <Flex boxSize='8em' direction='column' mb='1em' justify='center' align='center' border='1px solid' borderColor='gray.200' rounded='0.25em' p='0.5em'>

                <Image
                  src={logoFile[0]?.['logoUrl']} alt={""}
                  height='100px'
                />

              </Flex>
              {(logoFile) &&
                <Box mt='1.5em'>
                  {/* <LaunchdeckButton bg='brand.500' color='gray.50' fontSize='0.9em' onClick={handeUploadLogo} label='Upload image as logo' /> */}
                  <Box fontSize='0.8em' color='gray.500' mt='0.5em' fontStyle='italic' cursor='pointer' textAlign='center' onClick={() => setLogoFile(null)}>Use another image</Box>
                </Box>

              }
            </Box>
          }
          {errors &&
            <><RiErrorWarningLine color="red" boxSize={20} /> &nbsp; Upload limit is 10MB per image</>
          }
        </Box>
      )}
    </ImageUploading>
  )
}

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      uploadFiles,
      uploadFilesReset,
    },
    dispatch,
  );

const mapStateToProps = (state) => {
  return {
    uploadFilesState: state.uploadFilesOutcome,
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(CreatedDsrClientBranding);


